interface SeoProps {
  title: string;
  description?: string;
  keywords?: string;
}

export default function Seo({ title, description, keywords }: SeoProps) {
  return (
    <>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
    </>
  );
}